import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaTab from './VaTab.vue'

export const VaTab = withConfigTransport(_VaTab)
